import { useContext } from "react";
import { EntityAuthOption } from "src/services/link/queries/NetTypes";

import Context from "../../context";
import { default as CustomLoginSelector } from "./CustomLoginSelector";
import LoginSelector from "./LoginSelector";

// ----------------------------------------------------------------------

type Props = {
	onChangeSelect: (value: string) => void;
	selectedValue: string;
	values: EntityAuthOption[];
	label: string;
};

export const DLoginSelector = (props: Props) => {
	const { customConnectProps } = useContext(Context);

	const hasTheme = !!customConnectProps?.theme;

	return hasTheme ? <CustomLoginSelector {...props} /> : <LoginSelector {...props} />;
};

export default DLoginSelector;
